


module.exports = {
  "vacancies-feed":   {
    "index": () => import("../vacancies-feed/index.js"),
    "styles": () => import("../vacancies-feed/styles.js")
  }
}